<div class="product-promotion product-promotion__percentage product-promotion__percentage__msrp" fxLayoutGap="8px" *ngIf="msrpDiscount > number_0">
  - {{msrpDiscount}}%
</div>
